import { useEffect, useState } from "react";

const navItems = [
  { href: "#symptoms", label: "常见现象" },
  { href: "#causes", label: "原因分析" },
  { href: "#steps", label: "排查步骤" },
  { href: "#address", label: "地址失效" },
  { href: "#network", label: "网络屏蔽" },
  { href: "#safety", label: "安全提示" },
  { href: "#faq", label: "常见问答" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8 h-16 md:h-[72px] flex items-center justify-between">
        <a
          href="#top"
          className={`flex items-center gap-2 shrink-0 ${scrolled ? "text-foreground-950" : "text-white"}`}
        >
          <span
            className={`w-9 h-9 rounded-md flex items-center justify-center text-lg ${
              scrolled ? "bg-primary-500 text-background-50" : "bg-white/15 text-white"
            }`}
          >
            <i className="ri-play-circle-line"></i>
          </span>
          <span className="font-heading text-base md:text-lg font-semibold whitespace-nowrap">
            秋霞影院在线观看
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-1">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className={`px-3 py-2 text-sm rounded-md transition-colors whitespace-nowrap ${
                scrolled
                  ? "text-foreground-700 hover:text-primary-600 hover:bg-primary-50"
                  : "text-white/85 hover:text-white hover:bg-white/10"
              }`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a
            href="#steps"
            className="whitespace-nowrap px-4 py-2 text-sm rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
          >
            开始排查
          </a>
        </div>

        <button
          type="button"
          aria-label="打开导航菜单"
          onClick={() => setMenuOpen((v) => !v)}
          className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-md text-xl cursor-pointer ${
            scrolled ? "text-foreground-900 hover:bg-background-100" : "text-white hover:bg-white/10"
          }`}
        >
          <i className={menuOpen ? "ri-close-line" : "ri-menu-line"}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="lg:hidden bg-background-50 border-t border-background-200/70 px-4 pb-4 pt-2">
          <nav className="grid grid-cols-2 gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setMenuOpen(false)}
                className="px-3 py-2.5 text-sm rounded-md text-foreground-700 hover:bg-primary-50 hover:text-primary-700 transition-colors"
              >
                {item.label}
              </a>
            ))}
          </nav>
          <a
            href="#steps"
            onClick={() => setMenuOpen(false)}
            className="mt-3 block text-center whitespace-nowrap px-4 py-2.5 text-sm rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors"
          >
            开始排查
          </a>
        </div>
      )}
    </header>
  );
}